import { CompanyUser } from "../../../core/user/user.types";

export const MasterEndpointTargetSystemUri = 'master://OU=01/HttpServiceEndpointTargetSystem';

export const developerUri = 'userprofile://com.cloudcodice.thirdparty.grupoconstant.net2beeple.privileges.profile.UserProfileDeveloper';
export const adminUri = 'userprofile://com.cloudcodice.thirdparty.grupoconstant.net2beeple.privileges.profile.UserProfileAdmin';
export const backofficeUri = 'userprofile://com.cloudcodice.thirdparty.grupoconstant.net2beeple.privileges.profile.UserProfileBackoffice';

export interface MasterEndpointTargetSystem {
    _oid: string;
    _deprecated: boolean;
    _masterOrder: string;
    name: string;
    description: string;
    dnTransformer: string;
    logo: string;
    darkLogo: string;
    icon: string;
    [adminUri]?: UserProfile[];
    admin: (string | CompanyUser | UserProfile)[];
    role: UserNodePrivileges;
}

export const HttpServiceEndpointUri = 'master://OU=01/HttpServiceEndpoint';

export interface HttpServiceEndpoint {
    _oid: string;
    _deprecated: boolean;
    _masterOrder: string;
    name: string;
    endpointTargetSystem: string;
    counterpartEndpointOid: string;
    url: string;
    contentEncoding: string;
    authorizationType: string;
    authorizationKey: string;
    authorizationPassword: string;
    apiVersion: string;
    description: string;
    logo: string;
    darkLogo: string;
    icon: string;
    customPayload: any;
    [adminUri]?: UserProfile[];
    admin: (string | CompanyUser | UserProfile)[];
    [backofficeUri]?: UserProfile[];
    backoffice: (string | CompanyUser | UserProfile)[];
    role: UserNodePrivileges;
}

export interface BeepleClient {
    _oid: string;
    _deprecated: boolean;
    _masterOrder: string;
    endpointTargetSystem: string;
    endpoint: string;
    targetSystem?: MasterEndpointTargetSystem;
    httpEndpoint?: HttpServiceEndpoint;
    externalId: string;
    name: string;
    [adminUri]?: UserProfile[];
    admin: (string | CompanyUser | UserProfile)[];
    [backofficeUri]?: UserProfile[];
    backoffice: (string | CompanyUser | UserProfile)[];
    role: UserNodePrivileges;
}

export interface NextServicio {
    _oid: string;
    _deprecated: boolean;
    _masterOrder: string;
    endpointTargetSystem: string;
    endpoint: string;
    externalId: string;
    name: string;
    customPayload: string;
    nodeInfo: string;
    targetSystem?: MasterEndpointTargetSystem;
    httpEndpoint?: HttpServiceEndpoint;
    brand?: ServiceNodeInfo;
    client?: ServiceNodeInfo;
    project?: ServiceNodeInfo;
    [adminUri]?: UserProfile[];
    admin: (string | CompanyUser | UserProfile)[];
    [backofficeUri]?: UserProfile[];
    backoffice: (string | CompanyUser | UserProfile)[];
    role: UserNodePrivileges;
}

export interface ServiceNodeInfo {
    code: string;
    logoURL?: string;
    name: string;
}

export interface NextCalendar {
    _oid: string;
    _deprecated: boolean;
    belongsTo: string;
    belongsToDN: string;
    belongsToCaption: string;
    name: string;
    sameLocator: boolean;
    syncOid: string;
    weekDays: string[];
}

export interface Net4ConceptMapping {
    oid: string;
    logicalConcept: string;
    conceptType: ConceptTypeEnum;
    dispatchMode: DispatchModeEnum;
    net4Format: Net4FormatsEnum;
    roundInterval: number;
    roundPoint: number;
    net4ConceptId: number;
    net4ConceptName: string;
    empresaId: number;
    empresaName: string;
    clienteTipoAsignacion: string;
    from: string;
    to: string;
    excludeNet4ConceptId: string[];
    mustBeInBillingLine: boolean;
    net4ConceptFormula: string;
    score: number;
    codigoPuestoContrato: number;
    jobSupervisor: string;
    trabajadorNet4Id: number;
    trabajadorNet4Ids: number[];
    workplaceCode: string;
    payload;
}

export interface ConceptSummaryRowRequest {
    cols: {
        [oid: string]: ConceptSummaryColumnRequest;
    };
    displayName: string;
    empresaId: number;
    empresaName: string;
    key: string;
    sAMAccountName: string;
    trabajadorNet4Id: number;
    workplaceCode: string;
    originatorEndpointName: string;
    rowStatus: ConceptStatusEnum;
    summaryRow?: WorkplaceWorkSummaryRow;
}

export interface ConceptSummaryRow {
    approverDisplayName?: string;
    approverSAMAccountName?: string;
    approverTimestamp?: string;
    approverUserId?: string;
    cols: Map<number, ConceptSummaryColumn>;
    displayName: string;
    empresaId: number;
    empresaName: string;
    key: string;
    sAMAccountName: string;
    trabajadorNet4Id: number;
    workplaceCode: string;
    originatorEndpointName: string;
    rowStatus: ConceptStatusEnum;
    summaryRow?: WorkplaceWorkSummaryRow;
}

export interface ErrorConceptSummaryRow {
    net4WorkplaceWorkOID: string;
    targetSystemName: string;
    empresaId: number;
    empresaName: string;
    workplaceCode: string;
    workplaceParentId: string;
    originatorEndpointName: string;    
    displayName: string;
    sAMAccountName: string;
    trabajadorNet4Id: number;
    laboralContratoId: number;
    validationStatus?: string;
    approverDisplayName?: string;
    approverSAMAccountName?: string;
    approverTimestamp?: string;
    approverUserId?: string;
    dayOfMonth: number; 
    period: number;
    year: number;
    errorConceptSummaries: ErrorConceptSummary[];
}

export interface ConceptSummaryColumnRequest {
    calculatedValue: number;
    logicalConcept: string;
    net4ConceptId: number;
    statusInNet4: string;
    value: number;
    error: ConceptSummaryErrorDetails;
}

export interface ConceptSummaryColumn {
    oid: string
    calculatedValue: number;
    logicalConcept: string;
    net4ConceptId: number;
    statusInNet4: string;
    value: number;
    error: ConceptSummaryErrorDetails;
}

export interface WorkplaceWorkConceptSummaryTotalCol {
    net4ConceptId: number;
    calculatedValue: number;
    value?: number;
}

export interface ErrorConceptSummary {
    oid: string;
    statusInNet4: string;
    logicalConcept: string;
    net4ConceptId: number;
    net4ConceptName: string;
    calculatedValue: number;
    clienteContratoId: number;
    clienteContratoLinea: number;
    value: number;
    net4Value: number;          // Valor en base de datos de connect core
    realNet4Value?: number;     // Valor recuperado de Net4 despues de refrescar
    error:  ConceptSummaryErrorDetails;
}

export interface ConceptSummaryErrorDetails {
    error: string;
    net4Error: Net4Error;
    status: number;
    statusInNet4: string;
    timestamp: string;
}

export interface Net4Error {
    apiMethod: string;
    ms: number;
    remark: string;
    request: Net4Request | AlternativeNet4Request;
    response: Net4Response;
    timestamp: string;
    statusInNet4: string;
    status: number;
}

export interface Net4Request {
    BaseDeDatos: string;
    Empresa: number;
    DelegacionContratoServicios: number;
    ContratoServicios: number;
    LineaContratacion: number;
    DelegacionContratoLaboral: number;
    ContratoLaboral: number;
    Fecha: string;
    ConceptoFacturacion: number;
    Trabajador: number;
    Cantidad: number;
    Punteada: string;
}

export interface AlternativeNet4Request {
    BaseDatos: string;
    Fecha: string;
    ContratoLaboral: number;
    Empresa: number;
    CodigoDelegacionContratoLaboral: number;
    Centro: number;
    CPD: number;
    Cantidad: number;
    CodigoTrabajador: number;
    Concepto: number;
    Punteada: string;
}

export interface Net4Response {
    status: number;
    signed: boolean;
    message: string[];
    echo: any[];
}

export interface ConceptSummaryRowStatus {
    oid: string;
    approverDisplayName: string;
    approverSAMAccountName: string;
    approverTimestamp: string;
    approverUserId: string;
    status: ConceptStatusEnum;
    error: ConceptSummaryErrorDetails;
}

export interface ConceptField {
    conceptId: number;
    conceptName: string;
    type: ConceptTypeEnum;
    format: Net4FormatsEnum;
}

export enum ConceptStatusEnum {
    PENDING = 'PENDING',
    TRANSFERRED = 'TRANSFERRED',
    VALIDATED = 'VALIDATED',
    CLOSED = 'CLOSED',
    ERROR = 'ERROR'
}

export enum ConceptTypeEnum {
    BOOLEAN = 'BOOLEAN',
    INTEGER = 'INTEGER',
    TIME = 'TIME',
    DOUBLE = 'DOUBLE',
    PERCENT = 'PERCENT'
}

export enum DispatchModeEnum {
    DAILY = 'DAILY',
    MONTHLY = 'MONTHLY',
    NEVER = 'NEVER'
}

export enum Net4FormatsEnum {
    MINUTES = 'MINUTES',
    HOURS = 'HOURS',
    WORKDAYS = 'WORKDAYS'
}

export interface Net4AbsenceConcept {
    Codigo: string;
    Nombre: string;
    Prefix: string;
    ConceptosPresenciaAsociados?: Net4AbsenceConcept[];
}

export interface Net4Worker {
    trabajadorNet4Id: number;
    displayName: string;
}

export interface WorkplaceWorkSummaryRow {
    oid: string;
    empresaId: number;
    empresaName: string;
    workplaceCode: string;
    originatorEndpointName: string;
    trabajadorNet4Id: number;
    sAMAccountName: string;
    displayName: string;
    laboralContratoId: number;
    dayCell: WorkplaceWorkSummaryDayCell[];
    minutes: number;
    contractMinutesAccumulated: number;
    overwrittenContractPeriodMinutesAccumulated: number;
    diff: number;
    workedMinutes: number;
    minutesJustified: number;
    contractPeriodMinutesAccumulated: number;
    complementaryMinutes: number;
    complementaryPlusMinutes: number;
    extraMinutes: number;
    nightMinutes: number;
    nonWorkableMinutes: number;
    saturdayOffsetMinutes: number;
    sundayOffsetMinutes: number;
    vacationDays: number;
    mondayMinutes: number;
    tuesdayMinutes: number;
    wednesdayMinutes: number;
    thursdayMinutes: number;
    fridayMinutes: number;
    saturdayMinutes: number;
    sundayMinutes: number;
    numberOfWorkplaces: number;
}

export interface ContractWorkSummaryRow {
    oid: string; // ContractMonthlyOid
    rowStatus: ConceptStatusEnum;
    empresaId: number;
    empresaName: string;
    trabajadorNet4Id: number;
    laboralContratoId: number;
    sAMAccountName: string;
    displayName: string;
    workplaceData: Net4WorkplaceData[];
    dayCell: WorkplaceWorkSummaryDayCell[];

    activatedHourBag: boolean; // Bolsa Horas Activada
    minutes: number; // Horas totales
    contractMinutesAccumulated: number; // Horas contrato acumulado
    diff: number; // Horas totales - Horas contrato
    magicBagMinutes: number; // Horas totales - Horas contrato (validadas)
    workedMinutes: number; // Horas trabajadas
    minutesJustified: number; // Horas ausencia justificada
    contractPeriodMinutesAccumulated: number; // Horas contrato mes
    overwrittenContractPeriodMinutesAccumulated: number; // Horas contrato mes (overwrite)
    previousBagMinutes: number; // Bolsa Horas Anterior
    offsetBagMinutes: number; // Ajuste Manual de Bolsa
    currentBagMinutes: number; // Bolsa Horas Saldo
    compensationBagMinutes: number; // Horas a compensar de bolsa
    complementaryMinutes: number; // Horas complementarias
    complementaryPlusMinutes: number; // Horas complementarias que se abonan en un plus
    extraMinutes: number; // Horas extra
    extraPlusMinutes: number; // Horas extra que se abonan en un plus
    overTime: number; // Bolsa de horas 'pura'
    maxComplementaryMinutes: number; // Máximo de minutos complementarios
    maxExtraMinutes: number; // Máximo de minutos extra
    contractIsMaxLegalHours: number; // true -> NO EXISTEN HORAS COMPLEMENTARIAS
    nightMinutes: number; // Horas nocturnas
    nonWorkableMinutes: number; // Horas festivo (no laborable)
    vacationDays: number; // Días vacaciones
    annualVacationsDays: number; // Días vacaciones anuales
    maxAnnualVacationDays: number; // Días vacaciones anuales máximos
    mondayMinutes: number; // Horas lunes
    tuesdayMinutes: number; // Horas martes
    wednesdayMinutes: number; // Horas miércoles
    thursdayMinutes: number; // Horas jueves
    fridayMinutes: number; // Horas viernes
    saturdayMinutes: number; // Horas sábado
    saturdayOffsetMinutes: number; // Horas sábado a compensar
    sundayMinutes: number; // Horas domingo
    sundayOffsetMinutes: number; // Horas domingo a compensar
    plusDailyRatioOffsetMinutes: number;
    plusMonthlyRatioOffsetMinutes: number;
    plusMonthlyRatioOffsetMinutesAdj: number;
	plusDailyTimeOffsetMinutes: number;
	plusMonthlyTimeOffsetMinutes: number;
	plusMonthlyTimeOffsetMinutesAdj: number;
    supervisorPlusMinutes: number;
    supervisorPlusWithAttendance: number;
    withAttendance: number;
    saturdayWithAttendance: number;
    sundayWithAttendance: number;
    holidayWithAttendance: number;
}

export interface MonthlyContractWorkConceptSummaryRequest {
    key: string;
    cols: {
        [oid: string]: ConceptSummaryColumnRequest;
    };
    rowStatus: ConceptStatusEnum;
    empresaId: number;
    empresaName: string;
    trabajadorNet4Id: number;
    laboralContratoId: number;
    sAMAccountName: string;
    displayName: string;
    summaryRow: ContractWorkSummaryRow;
}

export interface MonthlyContractWorkConceptSummary {
    key: string;
    cols: Map<number, ConceptSummaryColumn>;
    rowStatus: ConceptStatusEnum;
    approverDisplayName?: string;
    approverSAMAccountName?: string;
    approverTimestamp?: string;
    approverUserId?: string;
    empresaId: number;
    empresaName: string;
    trabajadorNet4Id: number;
    laboralContratoId: number;
    sAMAccountName: string;
    displayName: string;
    summaryRow: ContractWorkSummaryRow;
}

export interface WorkplaceWorkSummaryDayCell {
    date: string;
    workable: boolean;
    holiday: boolean;
    workedMinutes: number;
    absenceMinutes: { [code: string]: number };
}

export interface Net4WorkerAssignment {
    clienteId: number;
    clienteCentroId: number;
    clienteContratoLinea: number;
    clienteContratoId: number;
    laboralContratoId: number;
    codigoPuestoContratoId: number;
    convenioContratoId: string;
    contractTypeId: number;
    from: string;
    to: string;
    semana: number;
    dia: number;
    lunes: number;
    martes: number;
    miercoles: number;
    jueves: number;
    viernes: number;
    sabado: number;
    domingo: number;
    codigoPuestoContratoName: string;
    convenioContratoName: string;
    contractTypeName: string;
}

export interface Net4WorkplaceData {
    originatorEndpointId: string;
    //originatorEndpointName: string;
    name: string;
    workplaceParentId: string;
    workplaceCode: string;
    guide: boolean;
    forced: boolean;
}

export interface ConfirmChanges {
    hasChanges: boolean;
}

export interface UserNodePrivileges {
    userId: string;
    sAMAccountName: string;
    OU: string;
    TS?: string;
    HS?: number;
    CL?: string;
    SV?: string;
    grantor: string;
    grantTimestamp: string;
    userDatatypeUri: string;
    systemConfig?: boolean;	//dev
    reloadLinkedData?: boolean;	//su
    nonLogicalMasterDeletion?: boolean;	//su
    adminProfile?: boolean;	//su
    adminMeAndChildren?: boolean;	//b
    masterDataManagement?: boolean;	//b
    payrollApprover?: boolean; //b
    payrollClosingManager?: boolean; //b
    calendarManagement?: boolean;
}

export interface UserProfile {
    OU?: string;
    TS?: string;
    HS?: string;
    CL?: string;
    SV?: string;
    active?: boolean;
    cn?: string;
    displayName?: string;
    userId?: string;
    sAMAccountName?: string;
    grantor?: string;
    grantorName?: string;
    grantTimestamp?: string;
    userDatatypeUri?: string;
    payload?: any;
    profileImage?: string;
    userPrincipalName?: string;
    telephoneNumber?: string;
}

export interface UserProfilePayload {
    userId?: string;
    payload?: any;
    action?: UserProfilePayloadAction;
}

export enum UserProfilePayloadAction {
    REVOKE = 'REVOKE',
    RESET = 'RESET',
    FLUSH = 'FLUSH'
}

export interface ReplyPartaker {
    'https://xml.cloudcodice.com/feature/company/User/1.1.0': { [key: string]: Partaker };
}

export interface Partaker {
    userPrincipalName: string;
    cn: string;
    sAMAccountName: string;
    displayName: string;
    active: boolean;
    profileImage: string;
}

export interface WeldonActivityRow {
    oid: string;
    logicalConcept: string;
    conceptType: ConceptTypeEnum;
    dispatchMode: DispatchModeEnum;
    net4Format: Net4FormatsEnum;
    roundInterval: number;
    roundPoint: number;
    net4ConceptId: number;
    net4ConceptName: string;
    empresaId: number;
    empresaName: string;
    clienteTipoAsignacion: string;
    from: string;
    to: string;
    excludeNet4ConceptId: string[];
    mustBeInBillingLine: boolean;
    net4ConceptFormula: string;
    score: number;
    codigoPuestoContrato: number;
    jobSupervisor: string;
    trabajadorNet4Id: number;
    trabajadorNet4Ids: number[];
    workplaceCode: string;
    payload;
}

export interface workerIdGroupStatus {
    id: string;
    inGroup: boolean;
}

export interface Net4WorkerGroup {
    oid: string;
    name: string;
    database: string;

    empresaId: number;
    delegacionId: number;
    convenioContratoId: number;
    contractTypeId: number;

    empresaName: string;
    delegacionName: string;
    convenioContratoName: string;
    contractTypeName: string;

    year: string;

    trabajadorNet4Ids: number[];

    annualVacationDays: number;
    vacationDaysType: string;

    annualExtraHours: number;

    paidRest: boolean;
    legalBreak: Net4LegalBreakThreshold[];
    deductMissingBreakMinutes: boolean;
    compensateBreakDeviation: boolean;
    applyToTransferredWorked: boolean;
    applyToTransferredPlanned: boolean;
    applyToTransferredCustom: boolean;
    workdaySplit: boolean;

    nocturnalFromTime: string;
    nocturnalToTime: string;

    ratioTimeAdjustment: number;
    complementaryHourMaxPercentage: number;

    excludedTrabajadorNet4Ids: number[];
	everyTrabajadorNet4Ids: number[];
}

export interface Net4WorkerSummary {
    displayName: string;
    sAMAccountName: string;
    trabajadorNet4Id: number;
}

export interface Net4LegalBreakThreshold {
    fromMinutes: number;
    breakMinutes: number;
}

export interface PartakerWorkers {
    [key: string]: { displayName: string, sAMAccountName: string, trabajadorNet4Id: number }
}